<template>
  <div class="login-page">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.login-page {
  height: 100%;
  background: linear-gradient(to right, #f5f5f5, #fff) no-repeat top left / 100%
    70%;
}
</style>
